import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import SetHeader from "../../../_components/_common/Header/SetHeader";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import N_tick from "../../../../src/assets/images/N_tick.png";
import N_wws_cat1 from "../../../../src/assets/images/wws_cat1.png";
import N_wws_cat2 from "../../../../src/assets/images/wws_cat2.png";
import N_wws_cat3 from "../../../../src/assets/images/wws_cat3.png";
import N_wws_cat4 from "../../../../src/assets/images/wws_cat4.png";
import N_wws_cat5 from "../../../../src/assets/images/wws_cat5.png";
import N_wws_cat6 from "../../../../src/assets/images/wws_cat6.png";
import ServiceContact from "../OurServises/ServiceContact";
import Subscribe from "../_mainHome/Subscribe";
import WebFooter from "../../../_components/_webapp/Footer/WebFooter";
class OurStory extends React.Component {
  render() {
    return (
      <React.Fragment>
        <SetHeader active={"story"} history={this.props.history}></SetHeader>
        <section className="Whoweservebanner">
          <Container>
            <Row>
              <Col>
                <div className="wws_banner_portion">
                  <div className="wws_banner_heading">
                    <h1>
                      {localStorage.getItem("warehouseCount")
                        ? localStorage.getItem("warehouseCount") + "+"
                        : "9600+"}
                      <MultiLanguageTranslation title=" Warehouses Across " />
                      {localStorage.getItem("districtCount")
                        ? localStorage.getItem("districtCount") + "+"
                        : "800+"}
                      <MultiLanguageTranslation title=" Locations" />
                    </h1>
                  </div>
                  <div className="wws_banner_heading_content">
                    <a href="/WhoWeServeFPO">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Farmer & FPO" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Processor">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Processors" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Agri_corporation">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Agri Corporations" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Financial">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Financial Institutions" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/InternationalBuyer">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="International Buyers" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/DevelopmentActors">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Development Actors" />
                      </span>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="N_wws_customBreadcumb">
                <Link onClick={() => this.props.history.push("/")}>
                  <MultiLanguageTranslation title="HOME" />
                </Link>{" "}
                <span>→</span>{" "}
                <strong>
                  {" "}
                  <MultiLanguageTranslation title="Who We Serve" />
                </strong>
              </div>
            </div>
          </div>
        </div>

        <section className="N_wws">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="N_wws_heading">
                  <h2>
                    <MultiLanguageTranslation title="Who We Serve" />
                  </h2>
                </div>
                <div className="wws_desc">
                  <p>
                    <MultiLanguageTranslation title="who_we_serve_page_title_of_the_total_cultivable" />
                  </p>
                  <p>
                    <MultiLanguageTranslation title="who_we_serve_page_title_It_work_with" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wws_categories">
          <Container>
            <Row>
              <Col>
                <div className="wws_cat_sec_2">
                  <div className="wws_cat_sec">
                    <img alt="" src={N_wws_cat1} />
                    <h5>
                      <MultiLanguageTranslation title="Farmers & Farmer Producer Organizations" />
                    </h5>
                    <p>
                      <MultiLanguageTranslation title="85% of the total cultivable land in India is held by small and marginal farmers. While they form a significant portion of the producer community, their value realization in the complete agriculture value chain is extremely limited." />
                    </p>
                    <button
                      className="N_button1"
                      onClick={() => this.props.history.push("/WhoWeServeFPO")}
                    >
                      Read More
                    </button>
                  </div>
                  <div className="wws_cat_sec">
                    <img alt="" src={N_wws_cat2} />
                    <h5>
                      <MultiLanguageTranslation title="Processors" />
                    </h5>
                    <p>
                      <MultiLanguageTranslation title="Agri-processing enterprises, both in the SME space and in the Large enterprises space, add significant value in the value chain of various commodities. These enterprises are required to procure, store and process large quantities of commodities." />
                    </p>
                    <button
                      className="N_button1"
                      onClick={() =>
                        this.props.history.push("/WhoWeServe/Processor")
                      }
                    >
                      Read More
                    </button>
                  </div>
                  <div className="wws_cat_sec">
                    <img alt="" src={N_wws_cat3} />
                    <h5>
                      <MultiLanguageTranslation title="Financial Institutions" />
                    </h5>
                    <p>
                      <MultiLanguageTranslation title="Financial Institutions play a very significant role in strengthening the agriculture value chains. They satisfy the financial needs of the various entities involved through their products and structures." />
                    </p>
                    <button
                      className="N_button1"
                      onClick={() =>
                        this.props.history.push("/WhoWeServe/Financial")
                      }
                    >
                      <MultiLanguageTranslation title="Read More" />
                    </button>
                  </div>
                  <div className="wws_cat_sec">
                    <img alt="" src={N_wws_cat4} />
                    <h5>Agri Corporations</h5>
                    <p>
                      <MultiLanguageTranslation title="National and Multinational Agri-Corporations procure commodities in large quantities for self-consumption and for domestic / international trade. They also provide farmers access to markets. Linkages with these agencies help in getting good prices besides providing access to information for farmers." />
                    </p>
                    <button
                      className="N_button1"
                      onClick={() =>
                        this.props.history.push("/WhoWeServe/Agri_corporation")
                      }
                    >
                      <MultiLanguageTranslation title="Read More" />
                    </button>
                  </div>
                  <div className="wws_cat_sec">
                    <img alt="" src={N_wws_cat5} />
                    <h5>
                      <MultiLanguageTranslation title="International Buyers" />
                    </h5>
                    <p>
                      <MultiLanguageTranslation title="India is a powerhouse for Agriculture. With its varied agro-climatic zones, the country boasts of producing a large variety of crops. The quality and price of these crops in the country make it a sought after destination for procurement by International buyers." />
                    </p>
                    <button
                      className="N_button1"
                      onClick={() =>
                        this.props.history.push(
                          "/WhoWeServe/InternationalBuyer"
                        )
                      }
                    >
                      <MultiLanguageTranslation title="Read More" />
                    </button>
                  </div>
                  <div className="wws_cat_sec">
                    <img alt="" src={N_wws_cat6} />
                    <h5>
                      <MultiLanguageTranslation title="Development Actors" />
                    </h5>
                    <p>
                      <MultiLanguageTranslation title="Development Actors comprising multilateral and bilateral agencies, philanthropies, government initiatives, non profit organisations, corporate social responsibility programmes, which are focussed on increasing farmer welfare and prosperity form a key client segment for us." />
                    </p>
                    <button
                      className="N_button1"
                      onClick={() =>
                        this.props.history.push("/WhoWeServe/DevelopmentActors")
                      }
                    >
                      <MultiLanguageTranslation title="Read More" />
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <ServiceContact />
        <section className="N_stay_update">
          <div className="container">
            <div className="row">
              <Subscribe></Subscribe>
            </div>
          </div>
        </section>
        <WebFooter />
      </React.Fragment>
    );
  }
}
export default OurStory;
